import {
  filterByStringProperty,
  FilterConfigSections,
  FilterConfigType,
  FilterOption,
  FilterSelectionSections,
  KeysOfType,
} from '@lib/utils';

export const getOptionsMatchingSearchParam = <
  TFilterOption extends FilterOption,
  Kstring extends KeysOfType<TFilterOption, string>,
>(
  options: TFilterOption[],
  searchByProperties: string[],
  searchParam?: string,
) => {
  if (!searchParam || !searchParam.length) return options;

  const option = options[0];
  const searchByProps = ['label' as Kstring, ...searchByProperties].filter(
    (key) => option.hasOwnProperty(key) && typeof option[key as keyof TFilterOption] === 'string',
  ) as Kstring[];

  return filterByStringProperty(options, searchParam, searchByProps);
};

export const getIsMatchingDynamicSelections = (
  currentSelection: FilterSelectionSections,
  dynamicFilterConfig: FilterOption['dynamicFilterConfig'],
) => {
  if (!dynamicFilterConfig) return true;

  const {sectionId, filterOptionId} = dynamicFilterConfig;
  return currentSelection?.[sectionId]?.includes(filterOptionId);
};

export type FilterOptionType = FilterConfigType<FilterOption>['type'];

export const generateFilterSectionType = (type: FilterOptionType) => {
  switch (type) {
    case 'singleMandatory':
    case 'singleOptional':
      return 'radio';
    case 'and':
    case 'or':
      return 'checkbox';
  }
};

export const getSectionsAsEmptyDependingOn = (
  filterConfig: FilterConfigSections,
  sectionId: string,
  filterId: string,
) =>
  Object.values(filterConfig).reduce((acc, section) => {
    if (!section?.data) return acc;
    const isThisSectionDependant = section.data.some(
      (option) =>
        option.dynamicFilterConfig?.sectionId === sectionId && option.dynamicFilterConfig.filterOptionId === filterId,
    );

    return isThisSectionDependant ? {...acc, [section.sectionId]: []} : acc;
  }, {} as FilterSelectionSections);

export type ShowingMorePerSectionType = {[key: string]: boolean};

export const getShowMorePerSection = (
  sectionsWithFilteredOptions: FilterConfigType<FilterOption>[],
  currentSelection: FilterSelectionSections = {},
): ShowingMorePerSectionType =>
  sectionsWithFilteredOptions.reduce(
    (acc, section): ShowingMorePerSectionType => ({
      ...acc,
      [section.sectionId]: currentSelection[section.sectionId]?.length,
    }),
    {},
  );
